import React from "react";

import Link from "core/Link";

import { useLoginFlow } from "../Context";

const ResetPasswordViewLink = ({ children }) => {
    const { goToPasswordReset } = useLoginFlow();

    return (
        <Link
            onClick={e => {
                e.preventDefault();
                goToPasswordReset();
            }}
            data-testid="reset-password-view-link"
            isButton
        >
            {children}
        </Link>
    );
};

export default ResetPasswordViewLink;
